// extracted by mini-css-extract-plugin
export var aboveInput = "_nw-0";
export var actionButton = "_nw-5";
export var actionButtonContainer = "_nw-1";
export var actionIcon = "_nw-6";
export var aiInfoContainer = "_nw-2";
export var attachmentWrapper = "_nw-7";
export var bold = "_nw-3";
export var checkIcon = "_nw-8";
export var clickingRecipientBar = "_nw-11";
export var commentThreadSwitch = "_nw-a";
export var draftImage = "_nw-b";
export var draftImageContainer = "_nw-c";
export var draftImages = "_nw-e";
export var editButton = "_nw-g";
export var editor = "_nw-f";
export var editorContainer = "_nw-y";
export var editorErrorTooltipWrapper = "_nw-9";
export var headerDivider = "_nw-h";
export var icon = "_nw-i";
export var info = "_nw-j";
export var internal = "_nw-n";
export var internalDivider = "_nw-k";
export var internalMessage = "_nw-l";
export var messageInputCard = "_nw-m";
export var messageInputForm = "_nw-o";
export var messageInputFormInternal = "_nw-p";
export var options = "_nw-q";
export var publicMessageCustomer = "_nw-s";
export var publicMessageMerchant = "_nw-r";
export var removeImageButton = "_nw-d";
export var replyButtons = "_nw-t";
export var showSignatureButton = "_nw-u";
export var spinner = "_nw-v";
export var verticalButtonDivider = "_nw-4";
export var visibilitySelector = "_nw-w";
export var warning = "_nw-x";
export var wrappingText = "_nw-z";
export var writingInternalNoteTopBorder = "_nw-10";